<div mat-dialog-title>
  <div i18n>Схема крепежа</div>
  <button mat-button class="mat-icon-button" mat-dialog-close aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="p-4 flex flex-row space-x-6 items-stretch">
  <div class="flex flex-col items-stretch flex-1">
    <p i18n class="mat-title">Отверстия</p>
    <mat-table class="fasteners-set-hole-table" #table [dataSource]="dataSource" fusePerfectScrollbar>
      <!-- X Column -->
      <ng-container matColumnDef="x">
        <mat-header-cell mat-header-cell *matHeaderCellDef>X</mat-header-cell>
        <mat-cell *matCellDef="let item">
          <p class="text-truncate">{{ item.x }}</p>
        </mat-cell>
      </ng-container>

      <!-- Y Column -->
      <ng-container matColumnDef="y">
        <mat-header-cell mat-header-cell *matHeaderCellDef>Y</mat-header-cell>
        <mat-cell *matCellDef="let item">
          <p class="text-truncate">{{ item.y }}</p>
        </mat-cell>
      </ng-container>

      <!-- Z Column -->
      <ng-container matColumnDef="z">
        <mat-header-cell mat-header-cell *matHeaderCellDef>Z</mat-header-cell>
        <mat-cell *matCellDef="let item">
          <p class="text-truncate">{{ item.z }}</p>
        </mat-cell>
      </ng-container>

      <!-- Diameter Column -->
      <ng-container matColumnDef="diameter">
        <mat-header-cell i18n mat-header-cell *matHeaderCellDef>Диаметр</mat-header-cell>
        <mat-cell *matCellDef="let item">
          <p class="text-truncate">{{ item.diameter }}</p>
        </mat-cell>
      </ng-container>

      <!-- Depth Column -->
      <ng-container matColumnDef="depth">
        <mat-header-cell i18n mat-header-cell *matHeaderCellDef>Глубина</mat-header-cell>
        <mat-cell *matCellDef="let item">
          <p class="text-truncate">{{ item.depth }}</p>
        </mat-cell>
      </ng-container>

      <!-- Type Column -->
      <ng-container matColumnDef="type">
        <mat-header-cell i18n mat-header-cell *matHeaderCellDef>Расположение</mat-header-cell>
        <mat-cell *matCellDef="let item">
          <ng-container [ngSwitch]="item.type">
            <p i18n class="text-truncate" *ngSwitchCase="2">Торец</p>
            <p i18n i18n-matTooltip class="text-truncate" *ngSwitchCase="1" matTooltip="Обратная сторона"
              >Обратная сторона</p
            >
            <p i18n i18n-matTooltip class="text-truncate" *ngSwitchCase="0" matTooltip="Лицевая сторона"
              >Лицевая сторона</p
            >
          </ng-container>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let item; columns: displayedColumns"></mat-row>
    </mat-table>
  </div>
  <div class="flex flex-row justify-center items-center basis-1/2">
    <csl-hole-group-schema-renderer
      [positionType]="data.positionType"
      [holes]="data.holes"></csl-hole-group-schema-renderer>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close i18n>ЗАКРЫТЬ</button>
</div>
